<template>

  <div>
    <div class="modal-backdrop" v-show="showForm"></div>
    <div class="card sc-modal" v-show="showForm">
      <div class="close sc">
        <i @click.self.prevent="showForm=false;"
           class="fas fa-times d-flex justify-content-center align-items-center"></i>
      </div>
      <div class="card-body border rounded-4 sc m-0">
        <h4 class="card-title sc">{{ t.CommonValues }}</h4>
        <hr class="m-0 p-0 sc">
        <div class="row row-cols-2 sc-pl20-pr-40 sc-title-container">
          <div class="col d-flex justify-content-start align-items-center p-0">
            <strong class="fs-6 fw-bolder w-100">{{ team }}</strong>
          </div>
          <div class="col d-flex justify-content-end align-items-center p-0">
            <label class="col-form-label fs-6 fw-light m-0">{{ playersCount }} ос.</label>
          </div>
        </div>
        <hr class="p-0 sc sc-mb-10">
        <div class="col d-flex flex-column align-items-center">
          <div class="row text-center d-flex values-block-top" v-for="value in top.slice(0, 3)">
            <div class="col-11 d-flex flex-grow-1 justify-content-center align-items-center p-0">
              <span class="p-0">{{ value.title }}</span>
            </div>
          </div>
        </div>
        <div class="col d-flex flex-column align-items-center sc-mt-15">
          <div class="row text-center d-flex values-block-top" v-for="value in top.slice(3)">
            <div class="col-11 d-flex flex-grow-1 justify-content-center align-items-center p-0">
              <span class="p-0">{{ value.title }}</span>
            </div>
          </div>
        </div>
        <hr class="p-0 sc sc-mt25-mb15">
        <p class="text-center"><b>{{ voteResult }}%</b> {{ t.AgreedWithResult }}</p>
      </div>
    </div>
  </div>
</template>

<script>

import {i18nMixin} from "@/mixins/i18n";

export default {
  name: 'results-modal',
  mixins: [i18nMixin],
  data: function () {
    return {
      showForm: false,
    }
  },
  props: ["open", "top", "team", "playersCount", "voteResult", "startDate"],
  watch: {
    open: function() {
      this.showForm = true;
    }
  },
  methods: {
  }
};
</script>

<style scoped>

.modal-backdrop {
  opacity: 0.9!important;
  z-index: 1;
}

.card.sc-modal {
  width: 370px;
  height: 600px;
  margin: 0;
  border-style: none;
  position: absolute;
  bottom: 15%;
  left: 35%;
  z-index: 2;
  background: none;
}

.close.sc {
  width: 30px;
  height: 30px;
  border: 2px solid #C4C4C4;
  border-radius: 15px;
  text-align: center;
  position: relative;
  top: 40px;
  left: 330px;
}

.close.sc i:hover {
  cursor: pointer;
}

.close.sc i {
  font-size: 10px;
  height: 26px;
}

.card-body.sc {
  margin: 0;
  width: 100%;
  height: 100%;
  padding: 0 25px 15px 25px;
  background-color: white;
}

.card-body.sc p {
  font-size: 16px;
}

.card-title.sc {
  font-size: 24px;
  line-height: 29px;
  font-weight: 700;
  margin-top: 20px;
  margin-bottom: 10px;
  text-align: center;
}

.values-block-top {
  border: 3px solid var(--bs-white);
  border-radius: 4px;
  min-height: 40px;
  max-height: 56px;
  color: black;
  width: 300px;
  margin: 0 0 -3px;
  height: 9%;
}

hr.sc {
  width: 100%;
  border-color: var(--bs-light);
}

.sc-mb-10 {
  margin: 0 0 10px;
}

.sc-mt-15 {
  margin-top: 15px;
}

.sc-mt25-mb15 {
  margin: 25px 0 15px;
}

.sc-pl20-pr-40 {
  padding-left: 35px;
  padding-right: 40px;
}
</style>
